import {
  REMOVE_RESOURCE,
  SET_CURRENT_RESOURCE,
  SET_FIRST_RESOURCE_IN_SERVICE} from "../constants";

const resourcesMainReducer = (state, action) => {
  switch (action.type) {
    case SET_CURRENT_RESOURCE:
      return {
        ...state,
        current: action.uri
      };
    case SET_FIRST_RESOURCE_IN_SERVICE: {
      const currentResource = state.items.find(
        resource => resource.service.$ref === action.serviceUri
      );
      return {
        ...state,
        current: currentResource && currentResource.$uri
      };
    }
    case REMOVE_RESOURCE:
      return {
        ...state,
        items: state.items.filter(
          resource => resource.$uri !== action.resource.$uri
        )
      };
    default:
      return state;
  }
};

export default resourcesMainReducer;
